import * as React from "react";
import * as ReactDOM from "react-dom";
import classnames from "classnames";
import * as styles from "./styles.scss";

export class CardContent extends React.Component<{ noMargin: boolean }, {}> {
  render() {
    return <>{this.props.children}</>;
  }
}
